import { defineAsyncComponent } from 'vue';

export const timeOffReportMicroFrontends = {
	TimeOffReport: defineAsyncComponent(
		() => import('./components/TimeOffReport')
	),
	TimeOffReportMetrics: defineAsyncComponent(
		() => import('./components/TimeOffReport/TimeOffReportMetrics.vue')
	),
};
